import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {Assets} from '~/QuickEcards/types/ecard';

type AssetsState = Assets;

const initialState: AssetsState = {
  reveals: [],
  overlays: [],
  backgrounds: [],
  envelopes: [],
  liners: [],
  stamps: [],
  stickers: [],
};

const assetsSlice = createSlice({
  name: 'assets',
  initialState,
  reducers: {
    updateAssets: (state, action: PayloadAction<Partial<Assets>>): AssetsState => ({
      ...state,
      ...action.payload,
    }),
  },
  selectors: {
    selectAssets: (state) => state,
  },
});

export const {updateAssets} = assetsSlice.actions;
export const {selectAssets} = assetsSlice.selectors;
export const assetsReducer = assetsSlice.reducer;
